"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _spinner = require("./spinner.helper");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Spinner = function Spinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 50 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'grey' : _ref$color,
    lightBackdrop = _ref.lightBackdrop,
    darkBackdrop = _ref.darkBackdrop,
    isThin = _ref.isThin,
    isExtraThin = _ref.isExtraThin,
    isSlow = _ref.isSlow,
    caption = _ref.caption,
    percent = _ref.percent,
    uniqueID = _ref.uniqueID;
  var overSize = size + 10;
  return _react.default.createElement("div", {
    className: "agillicSpinner",
    "data-testid": uniqueID
  }, _react.default.createElement("div", {
    className: "spinnerInnerWrapper",
    style: {
      width: overSize,
      height: overSize
    }
  }, _react.default.createElement("svg", {
    className: (0, _classnames.default)('spinner', color, {
      thin: isThin,
      extraThin: isExtraThin,
      slow: isSlow
    }),
    width: overSize,
    height: overSize
  }, !isNaN(lightBackdrop) && _react.default.createElement("circle", {
    stroke: "rgba(255, 255, 255, ".concat(lightBackdrop, ")"),
    cx: overSize / 2,
    cy: overSize / 2,
    r: overSize / 2 - 5
  }), !isNaN(darkBackdrop) && _react.default.createElement("circle", {
    stroke: "rgba(0, 0, 0, ".concat(darkBackdrop, ")"),
    cx: overSize / 2,
    cy: overSize / 2,
    r: overSize / 2 - 5
  }), _react.default.createElement("circle", {
    className: "stroke",
    cx: overSize / 2,
    cy: overSize / 2,
    r: overSize / 2 - 5
  })), caption && _react.default.createElement("div", {
    className: "caption"
  }, caption), !caption && !isNaN(percent) && _react.default.createElement("div", {
    className: "percent"
  }, Math.min((0, _spinner.precisionRound)(percent, 1), 100), "%")));
};
Spinner.propTypes = {
  size: _propTypes.number,
  color: (0, _propTypes.oneOf)(['switch', 'grey', 'purple', 'green', 'mint', 'coral', 'red', 'orange', 'white']),
  lightBackdrop: _propTypes.number,
  darkBackdrop: _propTypes.number,
  isThin: _propTypes.bool,
  isExtraThin: _propTypes.bool,
  isSlow: _propTypes.bool,
  caption: (0, _airbnbPropTypes.and)([_propTypes.string, (0, _propTypes2.forbiddenBy)('percent')]),
  percent: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _airbnbPropTypes.between)({
    gte: 0,
    lte: 100
  }), (0, _propTypes2.forbiddenBy)('caption')]),
  uniqueID: _propTypes.string
};
var _default = Spinner;
exports.default = _default;